export const recommendYoutubeList = [
    {
      title: '상처 많은 널 위로해줄 노래',
      youtuber: '뮤마Muma',
      videoId: 'nKbBTy7ioxI'
    },
    {
      title: '소리 내어 울지 못하는 그대에게',
      youtuber: '뮤마Muma',
      videoId: 'uMocVxNe6OU'
    },
    {
      title: '우리는 어째서 어른이 된 걸까',
      youtuber: 'MUTE',
      videoId: 'UqGn7T0Qysk'
    },
    {
      title: '위로받고 싶을 때 듣는 밍기뉴 플레이리스트',
      youtuber: '세제원샷',
      videoId: 'lwMEKstov4o'
    },
    {
      title: ' 괜찮아, 다 잘될거야. 힘들고 지친 당신을 위로해주는 노래🎵',
      youtuber: 'IsFp',
      videoId: 'uGa2cN1N5-Y'
    },
    {
      title: '꿈속에서는 울지 말아요 | 새벽 인디',
      youtuber: '소심 ᴘʟᴀʏʟɪsᴛ',
      videoId: '8Deo2CHTcNo'
    },
    {
      title: '지치고 힘든 당신에게 위로가 되는 드라마속 명대사',
      youtuber: '산소',
      videoId: '1ZZNJT6HpVg'
    },
    {
      title: '가슴 한편이 뭉클해지는 아이유 노래 모음 IU Touching songs PLAYLIST',
      youtuber: '아이유라는장르-GOIU PLAYLIST',
      videoId: 'CMYQVPAYJcQ'
    },
    {
      title: '𝑃𝑙𝑎𝑦𝑙𝑖𝑠𝑡 너무 슬플 때 울려고 들었던 노래',
      youtuber: 'dayt',
      videoId: 'uQ47sUutrRU'
    },
    {
      title: '😢 난 오늘 울어야겠어 이 노래 듣고 한참 울고 후련해지자 펑펑 울고 싶을 때 듣는 노래 [ 가사 있음 ] 광고없음 💽ㅣ파우제 플레이리스트',
      youtuber: '파우제 TV',
      videoId: 'yE-J9T-Z71U'
    },
    {
      title: '[Playlist] 노래 한소절에 울컥 눈물이 날때 | 감성 노래 모음',
      youtuber: '감성소녀',
      videoId: 'Tf4I5yfctjw'
    },
    {
      title:'떠나려 하는 모든 이에게',
      youtuber: '새던',
      videoId: 'iJyac4AXKKY'
    },

    {
      title:'우울할 때 들으면 더 우울해지는 노래ㅣplaylist',
      youtuber: 'outoff studio / 아웃오프 스튜디오',
      videoId: 'OirSByC9SNs'
    },
    {
      title:'[Playlist] 안 그래도 울고 싶은데 뺨 때리는 노래 모음| 새벽감성 발라드',
      youtuber: '감성소녀',
      videoId: 'JhZP-IUoFvo'
    },
  ];
  